import { useEffect, useState } from "react";
import { db, auth } from "../services/firebase";
import { ref, onValue, get } from "firebase/database";

/**
 * 🧮 Hook: useFetchTestMarks
 * Dynamically calculates total score & total questions
 * from /Tests/Evaluations/{uid}/{domainId}/{packId}/{interviewId}.
 */
export default function useFetchTestMarks(domainId, packId, interviewId) {
    const [marks, setMarks] = useState(null);
    const [loadingMarks, setLoadingMarks] = useState(true);

    useEffect(() => {
        const user = auth.currentUser;
        if (!user || !domainId || !packId || !interviewId) return;

        const evalRef = ref(
            db,
            `Tests/Evaluations/${user.uid}/${domainId}/${packId}/${interviewId}`
        );

        // ✅ Listen for live changes
        const unsubscribe = onValue(evalRef, async (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const questionIds = Object.keys(data);
                const scores = Object.values(data).map((e) => e?.score ?? 0);

                const totalScore = scores.reduce((a, b) => a + b, 0);
                const totalQuestions = questionIds.length;
                const maxScore = totalQuestions * 10;

                setMarks({
                    totalScore,
                    totalQuestions,
                    maxScore,
                    percentage:
                        totalQuestions > 0
                            ? ((totalScore / maxScore) * 100).toFixed(2)
                            : 0,
                });
            } else {
                // ⚠️ No evaluation data yet
                setMarks({
                    totalScore: 0,
                    totalQuestions: 0,
                    maxScore: 0,
                    percentage: 0,
                });
            }
            setLoadingMarks(false);
        });

        return () => unsubscribe();
    }, [domainId, packId, interviewId]);

    return { marks, loadingMarks };
}
